import { useEffect, useState } from "react";

/**
 * True only once `active` has held for `delayMs`. Used to keep fast states
 * from flashing: a capability check that resolves in 80ms should never paint
 * a spinner the visitor can see and not read.
 */
export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [elapsed, setElapsed] = useState(false);
  const [previousActive, setPreviousActive] = useState(active);

  // Adjusting state during render rather than in an effect: this has to reset
  // before paint, or re-entering the state would show instantly on the second
  // visit because the flag was still true from the first.
  if (previousActive !== active) {
    setPreviousActive(active);
    setElapsed(false);
  }

  useEffect(() => {
    if (!active) return;
    const timer = window.setTimeout(() => setElapsed(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [active, delayMs]);

  return active && elapsed;
}
